// @ts-nocheck

import GlobalOutlined from '@ant-design/icons/GlobalOutlined';
import TeamOutlined from '@ant-design/icons/TeamOutlined';
import TableOutlined from '@ant-design/icons/TableOutlined';
import SmileOutlined from '@ant-design/icons/SmileOutlined';
import CrownOutlined from '@ant-design/icons/CrownOutlined';
import DollarOutlined from '@ant-design/icons/DollarOutlined';
import VideoCameraOutlined from '@ant-design/icons/VideoCameraOutlined';
import ShopOutlined from '@ant-design/icons/ShopOutlined';
import FireOutlined from '@ant-design/icons/FireOutlined';
import Html5Outlined from '@ant-design/icons/Html5Outlined'

export default {
  GlobalOutlined,
TeamOutlined,
TableOutlined,
SmileOutlined,
CrownOutlined,
DollarOutlined,
VideoCameraOutlined,
ShopOutlined,
FireOutlined,
Html5Outlined
}
    